import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isResetHeight"];
import React, { forwardRef, memo } from 'react';
import { TeaserBanner } from '@beef/smart-kit';
import classNames from 'classnames/bind';
import { withAnalyticsBanner } from "../../hocs";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var _TeaserBannerView = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isResetHeight = _ref.isResetHeight,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('teaser-wrapper', !isResetHeight && 'teaser-wrapper--with_height'),
    ref: ref,
    "data-t-id": "components-TeaserBannerView"
  }, /*#__PURE__*/React.createElement(TeaserBanner, props));
}));
export var TeaserBannerView = withAnalyticsBanner(_TeaserBannerView, 'teaser');